import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDialogs } from '@cbridge-modules/dialog';
import { useDispatch } from '@cbridge-utils/react-redux';
import { NavigationItemContextMenu } from '@cbridge-tools/navigation-block';
import { NodeAction } from '@cbridge-packages/node';
import { NodeFormDialog } from '../_dialogs/NodeFormDialog';
import { IStreamNodeContextMenuProps } from './StreamNodeContextMenu.interface';

export const StreamNodeContextMenu: FunctionComponent<IStreamNodeContextMenuProps> = ({ item }) => {
  const { value, label } = item;
  const nodeId = value as number;

  const { t } = useTranslation();
  const dialogs = useDialogs();
  const dispatch = useDispatch();

  const handleDelete = async () => {
    const isProceed = await dialogs.confirmDelete(
      t('text:configPage.symbolPools.dialog.delete.description', '', { nodeName: label }),
      {
        title: t('text:configPage.symbolPools.dialog.delete.title'),
      },
    );
    if (isProceed) {
      dispatch(NodeAction.remove.started({ nodeId }));
    }
  };

  const handleEdit = async () => {
    const success = await dialogs.open(NodeFormDialog, { nodeId, formData: { name: label } });

    if (success) {
      dispatch(NodeAction.loadList.started({}));
    }
  };

  return (
    <NavigationItemContextMenu
      onEdit={handleEdit}
      onDelete={handleDelete}
    />
  );
};
